import React from 'react'
import { Provider } from 'mobx-react'
import { rootStoreInstance } from '../SearchBar/stores'
import CardCarousel from '../../Shared/CardCarousel'

const StatefulCardImage = props => (
  <Provider store={rootStoreInstance}>
    <CardCarousel {...props} />
  </Provider>
)

export default StatefulCardImage
